import { useController } from "react-hook-form";
import {
  FontAwesomeIcon,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  VeBox,
  VeTypography,
} from "../../mui";
import { makeStyles } from "@mui/styles";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import { VeTooltip } from "../VeTooltip/VeTooltip";
interface VeRadioGroupTypes {
  name: string;
  control?: any;
  options: any;
  customOnChange?: any;
  row?: any;
  selected?: string;
  infoIcon?: any;
  defaultValue?: any;
  error?: boolean;
  errorText?: string;
  grid?: number;
  disabled?: boolean;
  sx?: any;
}
const useStyles: any = makeStyles({
  radioLabel: {
    marginLeft: 0,
    marginTop: "2px",
    width: "100%",
    "@media (max-width:600px)": { marginTop: "12px" },
  },
  radio: {
    marginRight: "0px",
    "&.MuiRadio-root.Mui-checked": {
      color: "var(--vc-violet) !important",
    },
    "&.MuiRadio-root": {
      color: "#D5DBE1 !important",
      padding: "5px !important",
    },
    "&.MuiSvgIcon-root": {
      height: 10,
      width: 10,
    },
  },
  root: {
    width: 10,
    height: 10,
  },
});
export function VeRadioGroup({
  name,
  control,
  options,
  customOnChange,
  row = true,
  selected,
  infoIcon,
  defaultValue,
  error,
  errorText,
  grid = 0,
  disabled = false,
  sx,
}: VeRadioGroupTypes) {
  const {
    field: { value, onChange },
  } = control
    ? useController({
        name: name || "",
        control,
      })
    : { field: { value: "", onChange: () => {} } };
  const classes = useStyles();
  return (
    <>
      <RadioGroup
        row={row}
        value={customOnChange ? selected : (value ?? "")}
        onChange={customOnChange || onChange}
        sx={{ width: "100%", ...sx }}
      >
        {grid === 0
          ? options?.map((item: any) => (
              <FormControlLabel
                key={item?.value}
                value={item?.value}
                control={<Radio size="small" className={classes.radio} />}
                label={
                  <VeBox
                    display={"flex"}
                    justifyContent={"center"}
                    alignItems={"center"}
                  >
                    <VeTypography
                      variant="label2StrongSecondary"
                      sx={{ fontWeight: "400 !important" }}
                    >
                      {item?.label}
                    </VeTypography>
                    {item?.placeholder && (
                      <VeTooltip
                        placement="right-end"
                        title={
                          <VeBox
                            display={"flex"}
                            width={"185px"}
                            flexDirection={"column"}
                            padding={"8px"}
                          >
                            <VeTypography
                              variant="label3Secondary"
                              sx={{
                                color: "white !important",
                                fontSize: "12px",
                              }}
                            >
                              Select this if the shareholder has already been
                              added to the platform by your organisation
                            </VeTypography>
                          </VeBox>
                        }
                        arrow
                        sx={{ display: "flex", marginLeft: "5px" }}
                      >
                        {infoIcon}
                      </VeTooltip>
                    )}
                  </VeBox>
                }
                labelPlacement="end"
                disabled={item?.disabled || disabled || false}
                defaultValue={defaultValue}
                className={classes.radioLabel}
              />
            ))
          : options?.map((item: any) => (
              <Grid xl={grid} lg={grid} md={grid} xs={grid} sm={grid} item>
                <FormControlLabel
                  value={item?.value}
                  sx={{ justifyContent: "center" }}
                  control={<Radio size="small" className={classes.radio} />}
                  label={
                    <VeBox
                      display={"flex"}
                      justifyContent={"center"}
                      alignItems={"center"}
                    >
                      <VeTypography variant="label2Secondary">
                        {item?.label}
                      </VeTypography>
                      {item?.placeholder && (
                        <VeTooltip
                          placement="right-end"
                          title={
                            <VeBox
                              display={"flex"}
                              width={"185px"}
                              flexDirection={"column"}
                              padding={"8px"}
                            >
                              <VeTypography
                                variant="label3Secondary"
                                sx={{
                                  color: "white !important",
                                  fontSize: "12px",
                                }}
                              >
                                Select this if the shareholder has already been
                                added to the platform by your organisation
                              </VeTypography>
                            </VeBox>
                          }
                          arrow
                          // color="white"
                          sx={{ display: "flex", marginLeft: "5px" }}
                        >
                          {infoIcon}
                        </VeTooltip>
                      )}
                    </VeBox>
                  }
                  labelPlacement="end"
                  disabled={disabled || item?.disabled || false}
                  defaultValue={defaultValue}
                  className={classes.radioLabel}
                />
              </Grid>
            ))}
      </RadioGroup>
      {error && (
        <VeTypography
          style={{ marginLeft: "10px" }}
          variant="label4ErrorPrimary"
        >
          {errorText}
        </VeTypography>
      )}
    </>
  );
}
